import { render, staticRenderFns } from "./DriverPendingBalanceStatistics.vue?vue&type=template&id=70723bd0&"
import script from "./DriverPendingBalanceStatistics.vue?vue&type=script&lang=js&"
export * from "./DriverPendingBalanceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports